import SmartComponents, { SMART_COMPONENT_LIST } from "../index"; // Replace with your module's actual path

describe("SmartComponents", () => {
  SMART_COMPONENT_LIST.forEach(component => {
    it(`exports ${component} as a function`, () => {
      expect(typeof SmartComponents[component]).toBe("function");
    });
  });
});
